import { createActions } from 'redux-actions'

export const constants = {
  UPDATE_QUESTIONNAIRE_FORM_FIELD: 'UPDATE_QUESTIONNAIRE_FORM_FIELD',
  RESET_FORM_FIELDS: 'RESET_FORM_FIELDS',
  SUBMIT_FORM: 'SUBMIT_FORM'
}

export const actions = createActions({
  SUBMIT_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  RESET_FORM_FIELDS: (showMessage = true) => ({ showMessage })
})